import Switch from "@material-ui/core/Switch";
import styled from "styled-components";

export default styled(Switch)({});
